<div class="m-content">
	<!--Begin::Main Portlet-->
	<div class="m-portlet m-portlet--full-height">
		<!--begin: Portlet Head-->
		<div class="m-portlet__head">
			<div class="m-portlet__head-caption">
				<div class="m-portlet__head-title">
					<h3 class="m-portlet__head-text">
						Candidate Registration Form
					</h3>

				</div>
			</div>
			<div class="next-prev-btn-box">
				<div class="float-right next-btn">
					<a *ngIf="currentStep!=5" (click)="saveAndContinue()" class="btn btn-focus m-btn m-btn--custom m-btn--icon">
						<span>
							<span>
								Next
							</span>
						</span>
					</a>
					<button *ngIf="currentStep==5" (click)="submit()" class="btn btn-focus">
						<span>

							<!-- &nbsp;& nbsp; -->
							<span>
								Agree & Submit
							</span>
						</span>
					</button>

				</div>
				<div class="float-right previous-btn" *ngIf="currentStep>1">
					<a (click)="goBack()" class="btn btn-secondary m-btn m-btn--custom m-btn--icon">
						<span>
							<span>
								Previous
							</span>
						</span>
					</a>
				</div>
			</div>

		</div>
		<!--end: Portlet Head-->
		<!--begin: Portlet Body-->
		<div class="m-portlet__body m-portlet__body--no-padding">
			<!--begin: Form Wizard-->
			<div class="m-wizard m-wizard--3 m-wizard--success" id="m_wizard">
				<div class="m-row--no-padding">
					<div class="col-xl-12 col-lg-12">
						<div class="m-wizard m-wizard--1 m-wizard--success m-wizard--step-first" id="m_wizard">

							<div class="m-wizard__head m-portlet__padding-x">
								<!--begin: Form Wizard Progress -->
								<div class="m-wizard__progress">
									<div class="progress">
										<div class="progress-bar blue-bg" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width': currentStep==1 ? 'calc(20% + 28px)' : currentStep==2 ? 'calc(40% + 28px)' : currentStep==3 ? 'calc(60% + 28px)' : currentStep==4
                                        ? 'calc(80% + 28px)' : currentStep==5 ? 'calc(100% + 28px)' : 'calc(100% + 28px)'}"></div>
									</div>
								</div>
								<!--end: Form Wizard Progress -->

								<!--begin: Form Wizard Nav -->
								<div class="m-wizard__nav">
									<div class="m-wizard__steps">
										<div class="m-wizard__step" [ngClass]="{'m-wizard__step--current': currentStep==1 || currentStep>1}" m-wizard-target="m_wizard_form_step_1">
											<div class="m-wizard__step-info">
												<a class="m-wizard__step-number">
													<span>
														<span>1</span>
													</span>
												</a>
												<div class="m-wizard__step-line">
													<span></span>
												</div>
												<div class="m-wizard__step-label">
													Personal Details
												</div>
											</div>
										</div>
										<div class="m-wizard__step" [ngClass]="{'m-wizard__step--current': currentStep==2 || currentStep>2}" m-wizard-target="m_wizard_form_step_2">
											<div class="m-wizard__step-info">
												<a class="m-wizard__step-number">
													<span>
														<span>2</span>
													</span>
												</a>
												<div class="m-wizard__step-line">
													<span></span>
												</div>
												<div class="m-wizard__step-label">
													Contact Details
												</div>
											</div>
										</div>
										<div class="m-wizard__step" [ngClass]="{'m-wizard__step--current': currentStep==3 || currentStep>3}" m-wizard-target="m_wizard_form_step_3">
											<div class="m-wizard__step-info">
												<a class="m-wizard__step-number">
													<span>
														<span>3</span>
													</span>
												</a>
												<div class="m-wizard__step-line">
													<span></span>
												</div>
												<div class="m-wizard__step-label">
													Education Details
												</div>
											</div>
										</div>
										<div class="m-wizard__step" [ngClass]="{'m-wizard__step--current': currentStep==4 || currentStep>4}" m-wizard-target="m_wizard_form_step_4">
											<div class="m-wizard__step-info">
												<a class="m-wizard__step-number">
													<span>
														<span>4</span>
													</span>
												</a>
												<div class="m-wizard__step-line">
													<span></span>
												</div>
												<div class="m-wizard__step-label">
													Course Preferences
												</div>
											</div>
										</div>
										<div class="m-wizard__step" [ngClass]="{'m-wizard__step--current': currentStep==5 || currentStep>5}" m-wizard-target="m_wizard_form_step_5">
											<div class="m-wizard__step-info">
												<a class="m-wizard__step-number">
													<span>
														<span>5</span>
													</span>
												</a>
												<div class="m-wizard__step-line">
													<span></span>
												</div>
												<div class="m-wizard__step-label">
													Declaration & Submission
												</div>
											</div>
										</div>
									</div>
								</div>
								<!--end: Form Wizard Nav -->
							</div>
						</div>
					</div>
				</div>
				<!--begin: Message container -->
				<!--end: Message container -->
				<div class="m-row--no-padding">
					<div class="col-xl-12 col-lg-12">
						<!--begin: Form Wizard Form-->
						<div class="padding-30">

							<!-- 1) Use m-form--label-align-left class to alight the form input lables to the right
								 2) Use m-form--state class to highlight input control borders on form validation -->
							<form [formGroup]="applicantForm" class="m-form m-form--label-align-left- m-form--state-" id="m_form">
								<!--begin: Form Body -->
								<div class="">
									<p class="errMessage red">{{errorMsg}} </p>
									<!--begin: Form Wizard Step 1-->
									<div class="m-wizard__form-step" [ngClass]="{'m-wizard__form-step--current': currentStep==1 }" *ngIf="currentStep==1">
										<app-trainer-personal-info [(firstTimeLoad)]="firstTimeLoad"(isVerified)="aadharVerify = $event"[group]="applicantForm"></app-trainer-personal-info>
									</div>
									<div class="m-wizard__form-step" [ngClass]="{'m-wizard__form-step--current': currentStep==2 }" *ngIf="currentStep==2">
										<app-trainer-contact-details [group]="applicantForm"></app-trainer-contact-details>
									</div>
									<div class="m-wizard__form-step" [ngClass]="{'m-wizard__form-step--current': currentStep==3 }" *ngIf="currentStep==3">
										<app-trainer-education [(firstTimeLoad)]="firstTimeLoad" [group]="applicantForm"></app-trainer-education>
									</div>
									<div class="m-wizard__form-step" [ngClass]="{'m-wizard__form-step--current': currentStep==4 }" *ngIf="currentStep==4">
										<app-trainer-preferences [(firstTimePreferenceLoad)]="firstTimePreferenceLoad" (previous)="previous=$event" [group]="applicantForm"></app-trainer-preferences>
									</div>

									<div class="m-wizard__form-step" [ngClass]="{'m-wizard__form-step--current': currentStep==5 }" *ngIf="currentStep==5">
										<app-trainer-declaration [group]="applicantForm" (isCheck)="checkList.trainerDeclaratioin = $event"></app-trainer-declaration>
									</div>
								</div>
								<!--end: Form Body -->
								<!--begin: Form Actions -->
								<!--&&!this.applicantForm.get('contactDetails').valid(currentStep == 2)-->
								<div class="m-portlet__foot m-portlet__foot--fit m--margin-top-40">
									<div class="m-form__actions m-form__actions">
										<div class="row">
											<div class="col-lg-4"></div>
											<div class="col-lg-4 m--align-center" style="max-width: 12.33333%;">
												<button href="javascript:0;" *ngIf="currentStep!=5" [disabled]="(currentStep == 1&&!this.applicantForm.get('personalDetails').valid)||(currentStep == 2&&!this.applicantForm.get('contactDetails').valid)||(currentStep == 3&&!this.applicantForm.get('educationAndWorkDetails').valid)||(currentStep == 4&&!this.applicantForm.get('preferences').valid)"
												 (click)="saveAndContinue()" class="btn btn-next">
													<span>
														<span>
															Save & Next
														</span>


													</span>
												</button>
												<!-- <a href="javascript:0;" *ngIf="currentStep>1" (click)="saveAsDraft()" class="btn btn-secondary m-btn m-btn--custom m-btn--icon">
													<span>
														<span>
															Save As Draft
														</span>
													</span>
												</a> -->
												<button href="javascript:0;" *ngIf="currentStep==5" (click)="submit()"
												 class="btn btn-next m-btn m-btn--custom m-btn--icon">
													<span>

														<!-- &nbsp;& nbsp; -->
														<span>
															Agree & Submit
														</span>
													</span>
												</button>
											</div>
											<div class="col-lg-4 m--align-left">
												<button href="javascript:0;" *ngIf="currentStep!=5" (click)="saveAndDraft()" class="btn btn-secondary">
													<span>
														<span>
															Save As Draft
														</span>
													</span>
												</button>
											</div>
											<!--<div class="col-lg-2"></div>-->
										</div>
									</div>
								</div>
								<!--end: Form Actions -->
							</form>

						</div>
						<!--end: Form Wizard Form-->
					</div>
				</div>
			</div>
			<!--end: Form Wizard-->
		</div>
		<!--end: Portlet Body-->
	</div>
	<!--End::Main Portlet-->
</div>
